/**
Project: Voice Panel (c)
Title: New Subscriber Address Actions
Description: Component for adding the new subscriber address to the inventory.
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import axios from "axios";
import { AppConfigProps } from "../../../../core/settings/app-config";
import {
  logMessage,
  checkIdentitySession,
  getSessionExpiredError,
} from "../../../../core/actions/common-actions";

const actionFileName = "subscriber-address-actions.js";
const map_api_Key = process.env.REACT_APP_MICROSOFT_MAP_API_KEY;

export function searchAddress(query, cancelToken) {
  return new Promise(async function (resolve, reject) {
    await axios
      .get(
        process.env.REACT_APP_MICROSOFT_MAP_API_URL +
          `/search/address/json?subscription-key=${map_api_Key}&api-version=1.0&query=${query}`,
        cancelToken
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          logMessage(
            AppConfigProps.log.severityLevel.warning,
            actionFileName + ">getAtlasAddress()",
            AppConfigProps.httpStatusCode.clientClosedRequest,
            err.message
          );
        } else {
          reject(err.response);
        }
      });
  });
}

export function setSubscriberAddress(data, cancelToken) {
  return new Promise(async function (resolve, reject) {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      await axios
        .post(
          AppConfigProps.serverRoutePrefix + "/subscriber-address",
          data,
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          if (axios.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">setSubscriberAddress()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}
